import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setBlockedDomainEmails, setRegistrationFeature } from "../../../../../../../../store/actions/admin/create-event";
import { EventsState } from "../../../../../../../../store/types";
import ModalComponent from "../../../../../../../general-ui/modal/modal";
import Switch from "../../../../../../../general-ui/switch/switch";
import TagSelectInput from "../../../../../../../general-ui/tag-select/tag-select";

const AdvancedSettings: React.FC = () => {
	const {
		CreateEventReducer: {
			workingEvent
		},
	} = useSelector((state: EventsState) => state);
	const registration_settings = workingEvent?.registration_settings;
	const [editingBlockedList, setEditingBlockedList] = useState(false);
	const [workingBlockedEmails, setWorkingBlockedEmails] = useState<string[]>(registration_settings?.blockedDomainEmails ?? []);

	const dispatch = useDispatch();

	function editBlockedEmails() {
		setWorkingBlockedEmails(registration_settings?.blockedDomainEmails ?? []);
		setEditingBlockedList(true);
	}

	function finishedSettingBlock() {
		dispatch(setBlockedDomainEmails(workingBlockedEmails));
		setEditingBlockedList(false);
	}

	function setBlockedEmails(emails: string[]) {
		setWorkingBlockedEmails(emails);
	}
	function handleFeatureChange(value: string, on: boolean) {
		if (value === "useBlockedDomainEmails") setEditingBlockedList(on);
		dispatch(setRegistrationFeature(value, on));
	}

	const closeEditingBlockedList = useCallback(() => {
		setEditingBlockedList(false);
	}, []);

	return (
		<>
			<div className="settings-card">
				<label>
					Registration Confirmation
				</label>
				<Switch
					value={"registrationConfirmation"}
					on={registration_settings?.registrationConfirmation ?? false}
					onClick={handleFeatureChange}
				/>
			</div>
			<div className="settings-card">
				<button
					className="no-style blocked-emails-button"
					onClick={editBlockedEmails}
					disabled={!registration_settings?.useBlockedDomainEmails}
				>
					<label>
						Blocked Domain Emails
					</label>
				</button>
				<Switch
					value={"useBlockedDomainEmails"}
					on={!!registration_settings?.useBlockedDomainEmails ?? false}
					onClick={handleFeatureChange}
				/>
			</div>
			{/* <div className="settings-card">
                <label>Session Reminders</label>
                
                <Switch
                    value="sessionReminders"
                    on={registration_settings?.sessionReminders ?? false}
                    onClick={handleFeatureChange}
                />
            </div>
            <div className="settings-card">
                <label>Post Event Feedback Survey</label>
                <Switch
                    value="postEventFeedbackSurvey"
                    on={registration_settings?.postEventFeedbackSurvey ?? false}
                    onClick={handleFeatureChange}
                />
            </div> */}
			< ModalComponent
				open={editingBlockedList}
				onRequestClose={closeEditingBlockedList}
				title={"Blocked Email Domains"}
				cancellable={false}
				closeable={false}
				footer={(
					<>
						<button onClick={closeEditingBlockedList}>Cancel</button>
						<button onClick={finishedSettingBlock} className="primary">Apply</button>
					</>
				)}
			>
				<TagSelectInput
					onChange={setBlockedEmails}
					label={"Blocked Email Domains *"}
					initialTags={registration_settings?.blockedDomainEmails ?? []}
				/>
			</ModalComponent >
		</>
	);
};

export default AdvancedSettings;